module.exports = __webpack_public_path__ + "img/logo.2349a63c.png";